import type { ReactNode } from 'react'

/** Branded top bar: AYSO logo + REGION 13 / FIELD MANAGEMENT wordmark over the
 *  two-tone strip. Used by the signed-out Login frame and, on mobile, the
 *  signed-in shell. The `className` lets a caller gate visibility (e.g.
 *  `md:hidden`). */
export function Masthead({ headerRight, className = '' }: { headerRight?: ReactNode; className?: string }) {
  return (
    <div className={className}>
      <header className="masthead justify-between bg-sidebar">
        <div className="flex items-center gap-3 min-w-0">
          <img className="masthead-logo" src="/logo.svg" alt="AYSO Region 13" />
          <div className="wordmark">
            <span className="wordmark-title">REGION 13</span>
            <span className="wordmark-sub">FIELD MANAGEMENT</span>
          </div>
        </div>
        {headerRight}
      </header>
      <div className="strip" />
      <div className="strip-thin" />
    </div>
  )
}
